import { useState } from "react";
import { Link } from "react-router-dom";

const TARGETS = [
  { key: "artists", title: "Eine Künstlerin oder einen Künstler einladen", path: "/bewerbung/kuenstler",
    text: "Schau dir Kunst & Fund an: eine Plattform für Kunst und Fotokunst, die online und in passenden Lokalen sichtbar werden soll. Vielleicht wäre das etwas für deine Arbeiten? Hier erfährst du mehr und kannst dich melden:" },
  { key: "venues", title: "Ein Lokal zum Mitmachen einladen", path: "/bewerbung/lokal",
    text: "Vielleicht passt Kunst & Fund zu eurem Lokal: Kunst an euren Wänden, mit Künstlerinfos und QR-Link zum Werk. Welche Bilder passen und wie die Aufhängung läuft, wird persönlich abgestimmt. Hier könnt ihr euch das ansehen und Interesse melden:" },
];

export default function InviteLinks() {
  const [status, setStatus] = useState("");
  const origin = window.location.origin;
  const copy = async (value, key) => {
    try {
      await navigator.clipboard.writeText(value);
      setStatus(key === "link" ? "Link kopiert." : "Nachricht mit Link kopiert.");
    } catch {
      setStatus("Automatisches Kopieren nicht möglich. Markiere den angezeigten Link und kopiere ihn über das Gerätemenü.");
    }
  };
  return <section className="no-print border-2 border-[#121212] bg-[#F9D6D2] p-5 sm:p-7" data-testid="collaborator-invite-links">
    <h2 className="text-2xl font-black">Kennst du jemanden, für den das passen könnte?</h2>
    <p className="mt-3 text-sm">Du kannst die passende Seite direkt weiterschicken. Eine Nachricht wird erst verschickt, wenn du sie selbst in WhatsApp oder deinem Mailprogramm abschickst.</p>
    <div className="grid md:grid-cols-2 gap-5 mt-5">{TARGETS.map((target) => {
      const url = origin + target.path;
      const message = target.text + "\n" + url;
      return <article key={target.key} className="border border-[#121212] bg-white p-4" data-testid={`invite-share-${target.key}`}>
        <h3 className="font-black text-lg">{target.title}</h3>
        <Link to={target.path} className="block underline text-sm break-all mt-3 py-2">{url}</Link>
        <div className="flex flex-wrap gap-3 text-sm font-semibold mt-3">
          <button type="button" onClick={() => copy(url, "link")} className="underline py-2">Link kopieren</button>
          <button type="button" onClick={() => copy(message, "message")} className="underline py-2">Nachricht kopieren</button>
          <a href={`https://wa.me/?text=${encodeURIComponent(message)}`} target="_blank" rel="noopener noreferrer" className="underline py-2">WhatsApp</a>
          <a href={`mailto:?subject=${encodeURIComponent("Kunst & Fund – vielleicht etwas für euch?")}&body=${encodeURIComponent(message)}`} className="underline py-2">E-Mail</a>
        </div>
      </article>;
    })}</div>
    {status && <p role="status" className="mt-4 text-sm font-semibold">{status}</p>}
  </section>;
}
